import React, { useState } from 'react';
import LandingPage from './landingPage';
import RetrieveOptionFir from './retrieveOptionFir';
import RetrieveOptionSec from './retrieveOptionSec';
import MobileOtp from './mobileOtp';
import SingpassReg from './SingpassReg';
import NormalReg from './NormalReg';

// Import your CustomBoardNewLogin
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';

const OnboardingFlow = () => {
  const [currentPage, setCurrentPage] = useState('LandingPage');

  // Decide which component to show
  const renderPage = () => {
    switch (currentPage) {
      case 'LandingPage':
        return <LandingPage setPage={setCurrentPage} />;
      case 'RetrieveOptionFir':
        return <RetrieveOptionFir setPage={setCurrentPage} />;
      case 'RetrieveOptionSec':
        return <RetrieveOptionSec setPage={setCurrentPage} />;
      case 'MobileOtp':
        return <MobileOtp setPage={setCurrentPage} />;
      case 'SingpassReg':
        return <SingpassReg />;
      case 'NormalReg':
        return <NormalReg />;
      default:
        return <LandingPage setPage={setCurrentPage} />;
    }
  };

  // Example maintenance message (or return null if you don't need it)
  const renderMaintenanceChild = () => {
    return (
      // <div style={{ backgroundColor: '#F8F8F8', padding: '10px' }}>
      //   <p style={{ margin: 0 }}>Maintenance message goes here</p>
      // </div>
      <></>
    );
  };

  // (Optional) Just for demo, you could also set height/width dynamically
  const height = 800;
  const width = 600;

  return (
    <CustomBoardNewLogin
      maintenanceChild={renderMaintenanceChild()}
      children={renderPage()} // The main child/route content
      height={height}
      width={width}
    />
  );
};

export default OnboardingFlow;
